<template>
  <div class="contener">
    <div class="left">
      <a-button type="primary" @click="logData">
      选择
    </a-button>
    <a-button type="primary" @click="changeMode">
      change mode
    </a-button>
    <SelectCategory title="移动" :onSelect="getSelectId" model="REAED"/>
    </div>
    <div class="right">
      <BookmarkCard :bookMarkDetail="bookMark" :selectIds="selectIds" :showSelect="showSelect" :markMode="markMode"/>
    </div>
    <div class="right">
      <AddButton  :markMode="markMode" :currentCategory="{id:1,name:'测试'}"/>
    </div>
    <div>
      <iframe id="myiframe" src="https://blog.csdn.net/ResumeProject/article/details/108450483" scrolling="no"></iframe>
    </div>

    <div>
      <colorPicker v-model="color" v-on:change="headleChangeColor"/>
    </div>
  </div>
</template>

<script>
import BookmarkCard from "../../components/bookmark/bookmarkCard";
import AddButton from "../../components/bookmark/addButton";
import SelectCategory from "../../components/category/selectCategory";

export default {
  data() {
    return {
      bookMark: {
        id: 123,
        name: "百度一下",
        description:
          " 百度一下你就知道百度一下你就知道百度一下你就知道百度一下你就知道",
        icon: require("../../assets/logo.png"),
        url: "https://www.baidu.com",
        color:"#b89291"
      },
      testKeyWord:false,//按键测试
      selectIds:[],
      showSelect:false,
      markMode:'NORMAL',
      color: '#ff0000'
    };
  },
  components: {
    BookmarkCard,
    AddButton,
    SelectCategory
  },
  methods:{
      openEdit(){
        this.showEdit=true;
      },
      logData(){
        console.log(this.selectIds)
        this.showSelect = !this.showSelect;
      },
      changeMode(){
        if(this.markMode === 'NORMAL'){
           this.markMode = 'SIMPLE';
        }else{
          this.markMode = 'NORMAL';
        }
      },
      getSelectId(id){
        console.log(id);
      },
      headleChangeColor(c){
        console.log(c);
      }
  },
  created() {
    document.onkeydown = function () {
      var oEvent = window.event;
      //ctrl+q
      if (oEvent.ctrlKey && oEvent.keyCode == 81) {
       this.testKeyWord = true;
       alert(this.testKeyWord);
      }
    };
  },
};
</script>

<style  scoped>
.contener {
  background: #F8FAFB;
  width: 100%;
  height: 100vh;
}
.left {
  width: 280px;
  height: 100vh;
  padding-left: 20px;
  padding-top: 20px;
  float: left;
}
.right {
  padding-top: 20px;
  float: left;
  margin-left: 10px;
}
</style>